<template lang="pug">
  DefaultLayout
    CommonSection(title="События")
      PageSlug
        h1 Страница в разработке
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import PageSlug from '@/components/PageSlug.vue';

export default {
  name: 'EventsPage',
  components: { DefaultLayout, PageSlug, CommonSection },
};
</script>
